module.exports = __webpack_public_path__ + "static/media/pop.3a63af98.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/pop.mp3
// module id = 348
// module chunks = 0